import React from "react";
import { format } from "date-fns";
import { CheckCircle2, AlertTriangle, XCircle } from "lucide-react";
import { useLanguage } from "@/shared/components/shared/LanguageContext";

export default function LogEntry({ log, displayStatus, translateLogStatus }) {
  const { t } = useLanguage();

  const isUp = displayStatus === "UP";
  const isLow = displayStatus === "LOW";
  const isCritical = displayStatus === "CRITICAL";
  const isDown = displayStatus === "DOWN";

  return (
    <div
      className={`p-3 rounded-lg border ${
        isUp
          ? "bg-emerald-50 border-emerald-200"
          : isLow
            ? "bg-amber-50 border-amber-200"
            : isCritical
              ? "bg-red-50 border-red-200"
              : "bg-red-50 border-red-200"
      }`}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            {isUp ? (
              <CheckCircle2 className="h-4 w-4 text-emerald-600" />
            ) : isLow ? (
              <AlertTriangle className="h-4 w-4 text-amber-600" />
            ) : isCritical ? (
              <XCircle className="h-4 w-4 text-red-600" />
            ) : (
              <XCircle className="h-4 w-4 text-red-600" />
            )}
            <span
              className={`text-xs font-semibold ${
                isUp
                  ? "text-emerald-700"
                  : isLow
                    ? "text-amber-700"
                    : isCritical
                      ? "text-red-700"
                      : "text-red-700"
              }`}
            >
              {translateLogStatus(displayStatus)}
            </span>
            {log.latencyMs && (
              <span className="text-xs text-slate-500">
                • {t("latencyLabel")}: {log.latencyMs}ms
              </span>
            )}
          </div>
          <p className="text-xs text-slate-600">{format(new Date(log.createdAt), "PPpp")}</p>
          {isDown && (
            <p className="text-xs text-red-600 mt-1">{t("connectionFailed")}</p>
          )}
          {isCritical && (
            <p className="text-xs text-red-600 mt-1">{t("criticalLatencyDetected")}</p>
          )}
          {isLow && (
            <p className="text-xs text-amber-600 mt-1">{t("highLatencyDetected")}</p>
          )}
        </div>
      </div>
    </div>
  );
}
